<template><svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path d="M13,4H5v1h7v9h1V4z" />
	<path d="M4,11V2H3v10h8v-1H4z" />
	<rect x="14" y="11" width="1" height="1" />
	<rect x="1" y="4" width="1" height="1" />
	<rect x="5" y="6" width="6" height="4" />
</svg>
</template>